<template>
  <div class="about-page">
    <!-- Banner大图 -->
    <div class="banner">
      <img src="@/assets/home.jpg" alt="banner" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'WebBuild'
}
</script>

<style scoped>
/* Banner */
.banner {
  position: relative;
}
.banner img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
